import { FlatTreeNode } from 'types';

/** Build breadcrumb path string from a flat node list (e.g. "root > Connections Education"). */
export function buildBreadcrumb(node: FlatTreeNode, allNodes: FlatTreeNode[]): string {
  const parts: string[] = [node.name];
  const map = new Map(allNodes.map((n) => [n.id, n]));
  let current = node;
  while (current.idParent != null && map.has(current.idParent)) {
    current = map.get(current.idParent)!;
    parts.unshift(current.name);
  }
  return parts.join(' > ');
}

/** Collect all descendant IDs including self from a flat node list. */
export function getAllDescendantIds(nodes: FlatTreeNode[], rootId: number): number[] {
  const result = [rootId];
  const queue = [rootId];
  while (queue.length > 0) {
    const current = queue.shift()!;
    nodes.forEach((n) => {
      if (n.idParent === current) {
        result.push(n.id);
        queue.push(n.id);
      }
    });
  }
  return result;
}
